// extracted by mini-css-extract-plugin
export var deleteModal = "_re-0";